import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { parseTemplate } from "url-template";
import { RequestInit } from "atoms/models";

const leadInfoTemplate: any = parseTemplate("/ecommerce/route/leadInfo{?item,type,coreType,utmContent,utmMedium,utmSource,utmCampaign}");

export const leadInfo = async (
  leadInfo: object,
  item: string,
  type: string,
  coreType: string,
  utmContent: string,
  utmMedium: string,
  utmSource: string,
  utmCampaign: string
) => {
  const baseUrl = getBaseUrl();
  const relativeUrl = leadInfoTemplate.expand({
    item,
    type,
    coreType,
    utmContent,
    utmMedium,
    utmSource,
    utmCampaign,
  });
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "application/json");
  headers.append("Content-Type", "application/json");
  const body = JSON.stringify(leadInfo);
  const init: RequestInit = getRequestWithTokenInformation("POST", headers, body);
  const response = await window.fetch(input, init);
  const decodedJson = await response.json();
  return decodedJson;
};
